<template>
  <el-card>
    <template #header>
      <h3>{{ blockTitle }}</h3>
    </template>
    <div class="info-content">
      <a
        v-for="item in items"
        :key="item.title"
        :href="item.url"
        target="_blank"
      >
        <p>{{ item.title }}</p>
        <span v-html="item.description" />
      </a>
    </div>
  </el-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Info',
  props: {
    blockTitle: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      required: true
    }
  },
  setup() {}
})
</script>
<style lang="scss" scoped>
.info-content {
  a {
    display: block;
    padding: 12px 0;
    &:hover {
      color: rgb(var(--redesign-text-muted));
    }
  }
  p {
    margin: 0 0 8px;
    font-weight: 600;
  }
  a:not(:last-child) {
    margin: 0 0 8px;
    border-bottom: 1px solid rgb(var(--redesign-border));
  }
  span {
    font-size: 12px;
    color: rgb(var(--redesign-text-secondary));
    padding-right: 1rem;
    padding-bottom: 1px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}
</style>
